import React from 'react';
import { createPortal } from 'react-dom';
import useModalDialog from './useModalDialog';

const AddressSuggestionDialog = ({ suggestion, currentAddress, onAccept, onDismiss }) => {
  const dialogRef = useModalDialog();

  return createPortal(
    <dialog
      ref={dialogRef}
      className="case-address-dialog"
      aria-labelledby="case-address-dialog-title"
      aria-describedby="case-address-dialog-description"
      onCancel={(event) => {
        event.preventDefault();
        onDismiss();
      }}
    >
      <div className="d-flex align-items-start justify-content-between gap-3 p-4 pb-0">
        <h2 id="case-address-dialog-title" className="h5 mb-0">Dirección sugerida por el mapa</h2>
        <button type="button" className="btn-close flex-shrink-0" aria-label="Cerrar sugerencia" onClick={onDismiss} />
      </div>
      <div className="p-4">
        <p id="case-address-dialog-description" className="text-muted">
          Seleccionaste un punto en el mapa. Revisa la dirección antes de usarla.
        </p>
        {currentAddress ? (
          <div className="mb-3">
            <span className="form-text">Dirección actual</span>
            <p className="mb-0">{currentAddress}</p>
          </div>
        ) : null}
        <div className="case-address-dialog__suggestion">
          <span className="small">Dirección sugerida</span>
          <p className="fw-bold mb-1">{suggestion.address}</p>
          <p className="mb-0 small">
            {[suggestion.locality, suggestion.province, suggestion.country].filter(Boolean).join(', ')}
          </p>
        </div>
        <p className="form-text mb-0 mt-3">El punto seleccionado se conserva aunque no uses esta dirección.</p>
      </div>
      <div className="d-flex flex-wrap justify-content-end gap-2 p-4 pt-0">
        <button type="button" className="btn btn-outline-brand" onClick={onDismiss}>
          {currentAddress ? 'Mantener dirección actual' : 'Solo guardar el punto'}
        </button>
        <button type="button" className="btn btn-brand" onClick={onAccept}>
          {currentAddress ? 'Reemplazar por sugerencia' : 'Usar sugerencia de dirección'}
        </button>
      </div>
    </dialog>,
    document.body
  );
};

export default AddressSuggestionDialog;
